var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pixel-spinner',{staticClass:"mx-auto my-5",attrs:{"animation-duration":1000,"size":35,"color":"#ff1d5e"}})}
var staticRenderFns = []

export { render, staticRenderFns }